import React, { useEffect, useState } from "react";
import { Table, Button, Empty, Popover, Typography, Row, Col } from "antd";
import { useParams, useNavigate } from "react-router-dom";
import {
  WarningOutlined,
  ExclamationCircleOutlined,
  InfoCircleOutlined,
  LoadingOutlined,
  EyeOutlined,
  LeftOutlined,
  CloseCircleOutlined,
} from "@ant-design/icons";
import { translate, get_language } from "../../locale";
import DashServices from "../../services/DashServices";
import moment from "moment-timezone";

const { Title, Text } = Typography;

const PatientSelfEvaluationsAsignedTable = (reload) => {
  const [loading, setLoading] = useState(false);
  const { username } = useParams();
  const [data, setData] = useState([]);
  const [selectedSurvey, setSelectedSurvey] = useState(null);
  const [errorMsg, setErrorMsg] = useState("");

  useEffect(() => {
    if (reload !== null) {
      loadData();
    }
  }, [reload]);

  const loadData = async () => {
    setLoading(true);
    try {
      const res = await DashServices.getSelfEvaluationsAssign(username);
      if (res.status >= 200 && res.status < 300) {
        if (
          res.data.survey_user !== undefined &&
          res.data.survey_user.length > 0
        ) {
          setData(res.data.survey_user);
        }
        if (res.data.detail !== "") {
          const errors = {
            "You do not have permission to perform this action.": translate(
              "No tienes permisos para realizar esta acción"
            ),
          };
          setErrorMsg(errors[res.data.detail]);
        }
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };
  const navigate = useNavigate();

  const antIcon = (
    <LoadingOutlined
      style={{
        fontSize: 24,
      }}
      spin
    />
  );

  const columns = [
    /* {
      title: "",
      dataIndex: "actions",
      key: "actions",
      render: (_, record) => (
        <div className="flex space-x-2">
          <Button
            type="text"
            icon={<EyeOutlined />}
            size="small"
            className="border-0"
            onClick={() => setSelectedSurvey(record)}
          />
        </div>
      ),
    },
    {
      title: "Fecha y hora",
      dataIndex: "register_date",
      key: "register_date",
      render: (_, record) =>
        moment(record.register_date)
          .tz("UTC")
          .format(
            get_language === "en" ? "MM/DD/YYYY HH:mm" : "DD/MM/YYYY HH:mm"
          ),
      sorter: (a, b) => {
        if (a.register_date < b.register_date) return -1;
        if (a.register_date > b.register_date) return 1;
        return 0;
      },
    }, */
    {
      title: "Nombre",
      dataIndex: "name",
      key: "name",
      render: (_, record) => record.survey.title,
      sorter: (a, b) => {
        if (a.survey.title < b.survey.title) return -1;
        if (a.survey.title > b.survey.title) return 1;
        return 0;
      },
    },
    {
      title: "Resultado",
      dataIndex: "result",
      key: "result",
      render: (_, record) => {
        return record.answer.result ? record.answer.result : "-";
        /* let icon = null;
        let content = "";
        if (record.answer.result === "normal") {
          icon = <InfoCircleOutlined className="text-3xl text-custom_green" />;
        } else if (record.answer.result === "warning") {
          icon = <WarningOutlined className="text-3xl text-custom_yellow" />;
        } else if (record.answer.result === "danger") {
          icon = (
            <ExclamationCircleOutlined className="text-3xl text-custom_red" />
          );
        } else {
          return "";
        }
        if (record.answer.result_value) {
          content += record.answer.result_value;
        }
        if (record.answer.result_explain) {
          if (content !== "") {
            content += " ";
          }
          content += record.answer.result_explain;
        }
        return (
          <Popover content={content} trigger="hover">
            {icon}
          </Popover>
        ); */
      },


      filters: [
        {
          text: translate("Normal"),
          value: "normal",
        },
        {
          text: translate("Alerta"),
          value: "warning",
        },
        {
          text: translate("Peligro"),
          value: "danger",
        },
      ],
      onFilter: (value, record) => record.anwser.result.indexOf(value) === 0,
    },
    {
      title: "Estado",
      dataIndex: "status",
      key: "status",
      render: (_, record) => {
        if (record.answer.status === "complete") {
          return translate("Completo");
        } else if (record.answer.status === "incomplete") {
          return translate("Incompleto");
        }
      },
      sorter: (a, b) => {
        if (a.answer.status < b.answer.status) return -1;
        if (a.answer.status > b.answer.status) return 1;
        return 0;
      },
    },
    {
      title: translate("Remitente"),
      dataIndex: "sender",
      key: "sender",
      render: (_, record) => record.sender ? record.sender.fullname : "Protocolo automático",
    },
  ];

  return (
    <Row className="w-full">
      {selectedSurvey === null && (
        <Col span={24}>
          <Table
            rowKey={(i) => i.id}
            className="w-full"
            dataSource={data}
            columns={columns}
            loading={
              loading
                ? { indicator: antIcon, className: "text-custom_blue" }
                : false
            }
            locale={{
              emptyText:
                errorMsg === "" ? (
                  <Empty description={translate("No hay datos")} />
                ) : (
                  <Empty
                    image={<CloseCircleOutlined className="text-7xl mt-4" />}
                    description={translate(errorMsg)}
                  />
                ),
              sortTitle: translate("Ordenar"),
              triggerDesc: translate("Ordenar (descendente)"),
              triggerAsc: translate("Ordenar (ascendente)"),
              cancelSort: translate("Cancelar orden"),
              filterTitle: translate("Filtros"),
              filterConfirm: translate("Aceptar"),
              filterReset: translate("Limpiar"),
              filterEmptyText: translate("No hay filtros"),
              filterCheckall: translate("Seleccinar todos"),
              filterSearchPlaceholder: translate("Buscar en filtros"),
            }}
          />
        </Col>
      )}
    </Row>
  );
};

export default PatientSelfEvaluationsAsignedTable;
